module.exports = __webpack_public_path__ + "media/images/common/backtop_btn_l_ov-31d8cbdf425d9865815d3ab58658e739.png";